import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';

// --- INTRO ANIMATA ---
window.addEventListener('load', () => {
    const introOverlay = document.getElementById('intro-overlay');
    const curtainLeft = document.querySelector('.curtain-left');
    const curtainRight = document.querySelector('.curtain-right');
    const introLogo = document.querySelector('.intro-logo-beating');

    setTimeout(() => {
        introLogo.style.animation = 'none';

        introOverlay.classList.add('logo-exploding');

        curtainLeft.classList.add('curtain-open-left');
        curtainRight.classList.add('curtain-open-right');

        setTimeout(() => {
            introOverlay.classList.add('fade-out');
        }, 1200);

    }, 2000);
});


// --- DATI DEI PROGETTI ---
const progetti = {
    'vari': [
        {
            id: 'proj-vari-1', 
            titolo: 'Agrometeorological Station', 
            desc: 'From the RPi4 prototype to the custom ESP8266 PCB',
            modello: '/models_glb/cloud_lightning.glb',
            scala: 0.2,
            guida: `
                <p>
                    <img src="https://img.shields.io/badge/IoT-Project-blue" alt="IoT" style="margin:2px;">
                    <img src="https://img.shields.io/badge/-Raspberry_Pi-C51A4A?logo=Raspberry-Pi&logoColor=white" alt="Raspberry Pi" style="margin:2px;">
                    <img src="https://img.shields.io/badge/-ESP32-E7352C?logo=Espressif&logoColor=white" alt="ESP32" style="margin:2px;">
                    <img src="https://img.shields.io/badge/-ESP8266-000000?logo=Espressif&logoColor=white" alt="ESP8266" style="margin:2px;">
                    <img src="https://img.shields.io/badge/LoRa-Communication-007AFF" alt="LoRaWAN" style="margin:2px;">
                    <img src="https://img.shields.io/badge/ThingsBoard-Dashboard-0B2F83" alt="ThingsBoard" style="margin:2px;">
                    <img src="https://img.shields.io/badge/EasyEDA-PCB_Design-brightgreen" alt="EasyEDA" style="margin:2px;">
                </p>

                <p>Welcome to the repository of my <strong>Agrometeorological Station</strong><br>
                This project documents the evolution of the system, showing the transition from handmade DIY prototypes to the design of a custom stand-alone Printed Circuit Board (PCB).</p>

                <p align="center">
                  <img src="https://raw.githubusercontent.com/Francesco-Pagano/Agrometeorological-Station/main/images/Main.jpg" alt="Main Project Overview" class="guide-img" style="max-width: 350px;">
                </p>

                <hr style="border:0; border-top:1px solid rgba(255,255,255,0.1); margin: 2rem 0;">

                <h3>Data Visualization</h3>
                <p>All versions of this station send telemetry data to a server.<br>
                I developed an interactive dashboard on <strong>ThingsBoard</strong> for real-time monitoring of environmental and agricultural parameters.</p>

                <p align="center">
                  <img src="https://raw.githubusercontent.com/Francesco-Pagano/Agrometeorological-Station/main/images/Dashboard_Thingsboard.jpg" alt="ThingsBoard Dashboard" class="guide-img">
                </p>

                <hr style="border:0; border-top:1px solid rgba(255,255,255,0.1); margin: 2rem 0;">

                <h3>The Hardware & Software Journey</h3>
                <p>The project is structured into three iterations, each focused on a specific improvement: computing power, off-grid autonomy, and total hardware integration.</p>

                <h3><a href="https://github.com/Francesco-Pagano/Agrometeorological-Station/tree/main/v1_Pi4/" target="_blank" style="color: inherit; text-decoration: underline;">Version 1: The Foundations (Raspberry Pi 4)</a></h3>
                <p>The initial goal was to build a first, fully functional working prototype of a Weather Station using the Raspberry Pi 4 as the core platform.</p>
                <ul>
                    <li><strong>Source Code:</strong> <a href="https://github.com/Francesco-Pagano/Agrometeorological-Station/tree/main/v1_Pi4/code/" target="_blank" style="color:#4da6ff;">Python scripts</a></li>
                    <li><strong>Hardware Design:</strong> <a href="https://github.com/Francesco-Pagano/Agrometeorological-Station/tree/main/v1_Pi4/EasyEDA_Files/" target="_blank" style="color:#4da6ff;">EasyEDA/Gerber Files</a> and <a href="https://github.com/Francesco-Pagano/Agrometeorological-Station/blob/main/v1_Pi4/Schematic_ShieldPi4_WS.pdf" target="_blank" style="color:#4da6ff;">PDF Schematic</a></li>
                </ul>

                <p align="center" style="display: flex; gap: 10px; justify-content: center; align-items: center; flex-wrap: wrap;">
                  <img src="https://raw.githubusercontent.com/Francesco-Pagano/Agrometeorological-Station/main/v1_Pi4/img/Schematic_ShieldPi4_WS.png" alt="V1 Schematic" style="height: 150px; width: auto; max-width: 100%; border-radius: 5px;">
                  <img src="https://raw.githubusercontent.com/Francesco-Pagano/Agrometeorological-Station/main/v1_Pi4/img/3D_ShieldPi4_WS.png" alt="V1 3D Render" style="height: 150px; width: auto; max-width: 100%; border-radius: 5px;">
                  <img src="https://raw.githubusercontent.com/Francesco-Pagano/Agrometeorological-Station/main/v1_Pi4/img/PCB.png" alt="V1 Assembled PCB" style="height: 150px; width: auto; max-width: 100%; border-radius: 5px;">
                </p>
                <p align="center"><i>From left: Schematic, 3D Render, and assembled PCB on RPi4.</i></p>

                <hr style="border:0; border-top:1px solid rgba(255,255,255,0.1); margin: 2rem 0;">

                <h3><a href="https://github.com/Francesco-Pagano/Agrometeorological-Station/tree/main/v2_Pi0/" target="_blank" style="color: inherit; text-decoration: underline;">Version 2: Miniaturization & Field Deployment (RPi Zero)</a></h3>
                <p>In the second version, I focused on energy optimization and physical robustness for field deployment.<br>
                I switched to the <strong>Raspberry Pi Zero W</strong> and introduced standard <strong>RJ11</strong> connectors for commercial weather sensors (plug-and-play).</p>
                <ul>
                    <li><strong>Source Code:</strong> <a href="https://github.com/Francesco-Pagano/Agrometeorological-Station/tree/main/v2_Pi0/code/" target="_blank" style="color:#4da6ff;">Python scripts</a></li>
                    <li><strong>Hardware Design:</strong> <a href="https://github.com/Francesco-Pagano/Agrometeorological-Station/tree/main/v2_Pi0/EasyEDA_Files/" target="_blank" style="color:#4da6ff;">EasyEDA/Gerber Files</a> and <a href="https://github.com/Francesco-Pagano/Agrometeorological-Station/blob/main/v2_Pi0/Schematic_ShieldPi0_WS.pdf" target="_blank" style="color:#4da6ff;">PDF Schematic</a></li>
                </ul>

                <p align="center" style="display: flex; gap: 10px; justify-content: center; align-items: center; flex-wrap: wrap;">
                  <img src="https://raw.githubusercontent.com/Francesco-Pagano/Agrometeorological-Station/main/v2_Pi0/img/Schematic_ShieldPi0_WS.png" alt="V2 Schematic" style="height: 150px; width: auto; max-width: 100%; border-radius: 5px;">
                  <img src="https://raw.githubusercontent.com/Francesco-Pagano/Agrometeorological-Station/main/v2_Pi0/img/3D_ShieldPi0_WS.png" alt="V2 3D Render" style="height: 150px; width: auto; max-width: 100%; border-radius: 5px;">
                  <img src="https://raw.githubusercontent.com/Francesco-Pagano/Agrometeorological-Station/main/v2_Pi0/img/PCB.jpg" alt="V2 Deployed" style="height: 150px; width: auto; max-width: 100%; border-radius: 5px;">
                </p>
                <p align="center"><i>From left: Schematic, 3D Render, and assembled PCB.</i></p>

                <hr style="border:0; border-top:1px solid rgba(255,255,255,0.1); margin: 2rem 0;">

                <h3><a href="https://github.com/Francesco-Pagano/Agrometeorological-Station/tree/main/v3_Heltec_v2/" target="_blank" style="color: inherit; text-decoration: underline;">Version 3: Industrial IoT, LoRa & Solar Autonomy</a></h3>
                <p>The third iteration introduces long-range communication and off-grid energy independence.<br>
                The system is powered by a solar panel with an <strong>MPPT</strong> charge controller. I used two <strong>Heltec LoRa 32 v2</strong> (ESP32) modules for radio transmission and integrated a leaf wetness sensor via <strong>RS485</strong>.</p>
                <ul>
                    <li><strong>Firmware Code:</strong> <a href="https://github.com/Francesco-Pagano/Agrometeorological-Station/tree/main/v3_Heltec_v2/code/" target="_blank" style="color:#4da6ff;">C++ sketches</a></li>
                    <li><strong>Hardware Design:</strong> <a href="https://github.com/Francesco-Pagano/Agrometeorological-Station/tree/main/v3_Heltec_v2/EasyEDA_Files/" target="_blank" style="color:#4da6ff;">EasyEDA/Gerber Files</a> and <a href="https://github.com/Francesco-Pagano/Agrometeorological-Station/blob/main/v3_Heltec_v2/Schematic_ShieldHeltec_WS.pdf" target="_blank" style="color:#4da6ff;">PDF Schematic</a></li>
                </ul>

                <p align="center" style="display: flex; gap: 10px; justify-content: center; align-items: center; flex-wrap: wrap;">
                  <img src="https://raw.githubusercontent.com/Francesco-Pagano/Agrometeorological-Station/main/v3_Heltec_v2/img/Schematic_ShieldHeltec_WS.png" alt="V3 Schematic" style="height: 150px; width: auto; max-width: 100%; border-radius: 5px;">
                  <img src="https://raw.githubusercontent.com/Francesco-Pagano/Agrometeorological-Station/main/v3_Heltec_v2/img/3D_ShieldHeltec_WS.png" alt="V3 3D Render" style="height: 150px; width: auto; max-width: 100%; border-radius: 5px;">
                  <img src="https://raw.githubusercontent.com/Francesco-Pagano/Agrometeorological-Station/main/v3_Heltec_v2/img/PCB.png" alt="V3 Final Assembly" style="height: 150px; width: auto; max-width: 100%; border-radius: 5px;">
                </p>
                <p align="center"><i>From left: Schematic, 3D Render, and final Enclosure.</i></p>

                <hr style="border:0; border-top:1px solid rgba(255,255,255,0.1); margin: 2rem 0;">

                <h3><a href="https://github.com/Francesco-Pagano/Agrometeorological-Station/tree/main/v4_ESP8266/" target="_blank" style="color: inherit; text-decoration: underline;">Version 4: The Stand-Alone Custom PCB (WIP)</a></h3>
                <p>The state of the art and the natural evolution of the project.<br>
                In this version, currently under development, I am abandoning the concept of a "Shield" connected to a third-party dev-board. <br>
                I designed a single printed circuit board that directly integrates the <strong>ESP8266</strong> SoC (ESP-12F module).<br>
                This "all-in-one" approach drastically reduces production costs, power consumption, and physical footprint, representing a true hardware product ready for industrialization.</p>
                <ul>
                    <li><strong>Hardware Design:</strong> <a href="https://github.com/Francesco-Pagano/Agrometeorological-Station/tree/main/v4_ESP8266/EasyEDA_Files/" target="_blank" style="color:#4da6ff;">Work In Progress - EasyEDA Files</a></li>
                    <li><strong>Schematics:</strong> <a href="https://github.com/Francesco-Pagano/Agrometeorological-Station/blob/main/v4_ESP8266/Schematic_ESP8266_WS.pdf" target="_blank" style="color:#4da6ff;">PDF of the WIP schematic</a></li>
                </ul>

                <p align="center" style="display: flex; gap: 10px; justify-content: center; align-items: center; flex-wrap: wrap;">
                  <img src="https://raw.githubusercontent.com/Francesco-Pagano/Agrometeorological-Station/main/v4_ESP8266/img/Schematic_ESP8266_WS.png" alt="V4 Schematic" style="height: 250px; width: auto; max-width: 100%; border-radius: 5px;">
                  <img src="https://raw.githubusercontent.com/Francesco-Pagano/Agrometeorological-Station/main/v4_ESP8266/img/3D_ESP8266_WS.png" alt="V4 ESP8266 Standalone PCB" style="height: 250px; width: auto; max-width: 100%; border-radius: 5px;">
                </p>
                <p align="center"><i>Left: Schematic. Right: 3D Render of the PCB.</i></p>

                <hr style="border:0; border-top:1px solid rgba(255,255,255,0.1); margin: 2rem 0;">

                <div style="text-align: center; margin-top: 2.5rem; margin-bottom: 1rem;">
                    <a href="https://github.com/Francesco-Pagano/Agrometeorological-Station" target="_blank" style="text-decoration: none;">
                        <button class="btn-red" style="width: 100%; max-width: 400px; padding: 1rem;">
                            <i class="fab fa-github"></i> REPOSITORY GITHUB
                        </button>
                    </a>
                </div>
            `
        },
        {
            id: 'proj-vari-2', 
            titolo: 'DoorOTA', 
            desc: 'Sistema di apertura automatizzato per il pollaio',
            modello: '/models_glb/chicken.glb',
            scala: 3.5,
            guida: `
                <p>Sistema di apertura automatizzato per il pollaio</p><br>

                <p align="center">
                  <img src="https://raw.githubusercontent.com/Francesco-Pagano/DoorOTA/main/docs/img/Cover_DoorOTA.jpg" alt="Cover" class="guide-img" style="max-width: 350px;">
                </p>

                <p>
                    <img src="https://img.shields.io/badge/IoT-Project-blue" alt="IoT" style="margin:2px;">
                    <img src="https://shields.io/badge/PlatformIO-E37B0D?style=flat&logo=platformio&logoColor=white" alt="PlatformIO" style="margin:2px;">
                    <img src="https://img.shields.io/badge/Dashboard-ThingsBoard-0B2F83" alt="ThingsBoard" style="margin:2px;">
                    <img src="https://img.shields.io/badge/-ESP32-E7352C?logo=Espressif&logoColor=white" alt="ESP32" style="margin:2px;">
                    <img src="https://img.shields.io/badge/OTA-46923c" alt="OTA" style="margin:2px;">
                </p>

                <h3>Schema</h3>
                <p align="center">
                  <img src="https://raw.githubusercontent.com/Francesco-Pagano/DoorOTA/main/docs/img/schematics/Schematic_DoorOTA.png" alt="Schematic" class="guide-img" style="max-width: 350px;">
                </p>

                <h3>Pagina web</h3>
                <p align="center">
                  <img src="https://raw.githubusercontent.com/Francesco-Pagano/DoorOTA/main/docs/img/instr/Web.png" alt="Pagina Web" class="guide-img" style="max-width: 350px;">
                </p>

                <h3>Dashboard Thingsboard</h3>
                <p align="center">
                  <img src="https://raw.githubusercontent.com/Francesco-Pagano/DoorOTA/main/docs/img/instr/Thingsboard.jpg" alt="Thingsboard" class="guide-img" style="max-width: 350px;">
                </p>

                <div style="text-align: center; margin-top: 2.5rem; margin-bottom: 1rem;">
                    <a href="https://github.com/Francesco-Pagano/DoorOTA" target="_blank" style="text-decoration: none;">
                        <button class="btn-red" style="width: 100%; max-width: 400px; padding: 1rem;">
                            <i class="fab fa-github"></i> REPOSITORY GITHUB
                        </button>
                    </a>
                </div>
            `
        },
        { 
            id: 'proj-vari-3', titolo: 'Progetto 3', desc: 'In arrivo a breve',
            guida: '<p>Prossimamente</p>'
        }
    ],
    '3d': [
        {
            id: 'proj-3d-1', titolo: 'Progetto 1', desc: 'In arrivo a breve',
            guida: '<p>Prossimamente</p>'
        } /*
        {
            id: 'proj-3d-2', titolo: 'Test', desc: 'Test con texture', modello: '../static/test.glb',
            guida: `
                <h3>1. Progettazione</h3>
                <p>Bla bla bla</p>
                <img src="../static/Logo.png" alt="Logo" class="guide-img">

                <h3>2. Bla Bla </h3>
                <ul>
                    <li><strong>Materiale:</strong> Bla</li>
                    <li><strong>Layer:</strong> 0.2mm</li>
                    <li><strong>Infill:</strong> 30%</li>
                </ul>
                <img src="../static/Logo.png" alt="Logo" class="guide-img">
            `
        }*/
    ],
    'laser': [
        { 
            id: 'proj-laser-1', titolo: 'Progetto 1', desc: 'In arrivo a breve',
            guida: '<p>Prossimamente</p>'
        }
    ],
    'cnc': [
        { 
            id: 'proj-cnc-1', titolo: 'Progetto 1', desc: 'In arrivo a breve',
            guida: '<p>Prossimamente</p>'
        }
    ]
};

let miniRenderers = [];
let miniAnimFrames = [];

function cleanupMiniScenes() {
    miniAnimFrames.forEach(id => cancelAnimationFrame(id));
    miniAnimFrames = [];
    miniRenderers.forEach(r => r.dispose());
    miniRenderers = [];
}

const mainMenu = document.getElementById('main-menu');
const galleryView = document.getElementById('gallery-view');
const galleryTitle = document.getElementById('gallery-title');
const galleryGrid = document.getElementById('gallery-grid');

const modalOverlay = document.getElementById('project-modal');
const modalTitle = document.getElementById('modal-title');
const modalBody = document.getElementById('modal-body');
const closeModalBtn = document.getElementById('close-modal');

function closeModal() {
    modalOverlay.classList.add('hidden');
}
closeModalBtn.addEventListener('click', closeModal);
modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) closeModal();
});

function openGallery(categoria, titolo, classeColore, coloreEsadecimale) {
    mainMenu.classList.add('hidden');
    galleryView.classList.remove('hidden');
    galleryTitle.textContent = `Progetti: ${titolo}`;
    galleryTitle.className = classeColore || '';

    cleanupMiniScenes();
    galleryGrid.innerHTML = '';

    progetti[categoria].forEach(prog => {
        const card = document.createElement('div');
        card.className = 'project-card';
        card.innerHTML = `
            <div id="mini-canvas-${prog.id}" class="project-model-container"></div>
            <h3>${prog.titolo}</h3>
            <p>${prog.desc}</p>
            <button class="btn-guide" id="btn-guide-${prog.id}">INFO</button>
        `;
        galleryGrid.appendChild(card);

        initMiniScene(`mini-canvas-${prog.id}`, coloreEsadecimale, prog.modello, prog.scala);

        document.getElementById(`btn-guide-${prog.id}`).addEventListener('click', () => {
            modalTitle.textContent = prog.titolo;
            modalTitle.className = classeColore || '';
            modalBody.innerHTML = prog.guida;
            modalOverlay.classList.remove('hidden');
        });
    });
}

function initMiniScene(containerId, colorHex, modelloPath, scalaModello = 0.2) {
    const container = document.getElementById(containerId);
    if (!container) return;

    const w = container.clientWidth;
    const h = container.clientHeight;

    const miniScene = new THREE.Scene();
    const miniCamera = new THREE.PerspectiveCamera(45, w / h, 0.1, 100);
    miniCamera.position.z = 4;

    const miniRenderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    miniRenderer.setSize(w, h);
    miniRenderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    miniRenderer.outputColorSpace = THREE.SRGBColorSpace;
    miniRenderer.toneMapping = THREE.ACESFilmicToneMapping;

    container.appendChild(miniRenderer.domElement);

    const miniControls = new OrbitControls(miniCamera, miniRenderer.domElement);
    miniControls.enableDamping = true;
    miniControls.enableZoom = false;

    miniScene.add(new THREE.AmbientLight(0xffffff, 1.8));

    const mainLight = new THREE.DirectionalLight(0xffffff, 3.5);
    mainLight.position.set(1, 3, 2.5);
    miniScene.add(mainLight);

    let currentMesh;

    if (modelloPath) {
        const headerLogo = document.getElementById('btn-logo');

        const loadingImg = document.createElement('img');
        loadingImg.className = 'loading-logo';

        if (headerLogo) {
            loadingImg.src = headerLogo.src;
        } else {
            loadingImg.src = './static/Logo.png'; 
        }
        container.appendChild(loadingImg);

        const loader = new GLTFLoader();
        loader.load(
            modelloPath,
            function (gltf) {
                setTimeout(() => {
                if (container.contains(loadingImg)) {
                    container.removeChild(loadingImg);
                }

                const model = gltf.scene;
                model.scale.set(scalaModello, scalaModello, scalaModello);

                const box = new THREE.Box3().setFromObject(model);
                const center = box.getCenter(new THREE.Vector3());

                model.position.sub(center);
                currentMesh = new THREE.Group();
                currentMesh.add(model);

                miniScene.add(currentMesh);
                }, 1500);
            },
            function (xhr) {
                // Barra di caricamento
            },
            function (error) {
                setTimeout(() => {
                if (container.contains(loadingImg)) {
                    container.removeChild(loadingImg);
                }
                console.error('Errore nel caricamento del modello 3D:', error);
                }, 1500);
            }
        );
    } else {
        const geometry = new THREE.IcosahedronGeometry(1.2, 0);
        const material = new THREE.MeshStandardMaterial({
            color: colorHex,
            wireframe: true,
            roughness: 0.2,
            metalness: 0.8
        });
        currentMesh = new THREE.Mesh(geometry, material);
        miniScene.add(currentMesh);
    }

    miniRenderers.push(miniRenderer);

    let animId;
    function animateMini() {
        animId = requestAnimationFrame(animateMini);

        if (currentMesh) {
            currentMesh.rotation.y += 0.005;
            // Se è un modello reale, non ruotare su X per evitare che vada a testa in giù
            if (!modelloPath) currentMesh.rotation.x += 0.002;
        }

        miniControls.update();
        miniRenderer.render(miniScene, miniCamera);
    }
    animateMini();
    miniAnimFrames.push(animId);

    const resizeObserver = new ResizeObserver(() => {
        if (container.clientWidth > 0 && container.clientHeight > 0) {
            miniCamera.aspect = container.clientWidth / container.clientHeight;
            miniCamera.updateProjectionMatrix();
            miniRenderer.setSize(container.clientWidth, container.clientHeight);
        }
    });
    resizeObserver.observe(container);
}

// --- SCENA PRINCIPALE ---
const mainScene = new THREE.Scene();
mainScene.fog = new THREE.FogExp2('#111111', 0.02);
const mainCamera = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 0.1, 1000);
const mainRenderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
mainRenderer.setSize(window.innerWidth, window.innerHeight);
mainRenderer.outputColorSpace = THREE.SRGBColorSpace;
mainRenderer.toneMapping = THREE.ACESFilmicToneMapping;
mainRenderer.toneMappingExposure = 1.0;
document.getElementById('canvas-container').appendChild(mainRenderer.domElement);

const mainControls = new OrbitControls(mainCamera, mainRenderer.domElement);
mainControls.enableDamping = true;


// --- LUCI ---
mainScene.add(new THREE.AmbientLight(0xffffff, 0.5));

const mainSpotLight = new THREE.SpotLight(0xffffff, 5);
mainSpotLight.position.set(0, 20, 10);
mainScene.add(mainSpotLight);

const lightPrinter = new THREE.PointLight(0xf44336, 25, 50);
lightPrinter.position.set(-8, 3, -2);

const lightLaser = new THREE.PointLight(0x20be0c, 15, 40);
lightLaser.position.set(0, 2, -7);

const lightCNC = new THREE.PointLight(0x4da6ff, 15, 40);
lightCNC.position.set(8, 2, -4);

mainScene.add(new THREE.GridHelper(40, 40, 0x333333, 0x222222)).position.y = -2;

const materialiSfondo = {
    metallo: new THREE.MeshStandardMaterial({ color: 0x888888, metalness: 0.8 }),
    scuro: new THREE.MeshStandardMaterial({ color: 0x222222 }),
    rosso: new THREE.MeshStandardMaterial({ color: 0xf44336, metalness: 0.3, roughness: 0.4 }),
    verde: new THREE.MeshStandardMaterial({ color: 0x20be0c, metalness: 0.3, roughness: 0.4 }),
    blu: new THREE.MeshStandardMaterial({ color: 0x4da6ff, metalness: 0.3, roughness: 0.4 })
};

const printer = new THREE.Group();
printer.add(new THREE.Mesh(new THREE.BoxGeometry(3, 0.5, 3), materialiSfondo.rosso));
const pExtruder = new THREE.Mesh(new THREE.BoxGeometry(0.4, 0.6, 0.4), materialiSfondo.scuro);
pExtruder.position.y = 2; printer.add(pExtruder);
printer.position.set(-8, -1.75, -5); mainScene.add(printer);

const laser = new THREE.Group();
laser.add(new THREE.Mesh(new THREE.BoxGeometry(5, 1.5, 3.5), materialiSfondo.verde));
const lHead = new THREE.Mesh(new THREE.CylinderGeometry(0.1, 0.1, 0.4), materialiSfondo.scuro);
lHead.position.set(-1, 0.5, 0); laser.add(lHead);
laser.position.set(0, -1.25, -8); mainScene.add(laser);

const cnc = new THREE.Group();
cnc.add(new THREE.Mesh(new THREE.BoxGeometry(4, 1, 4), materialiSfondo.blu));
const cSpindle = new THREE.Mesh(new THREE.CylinderGeometry(0.2, 0.1, 1), materialiSfondo.metallo);
cSpindle.position.set(0, 1.8, 0.4); cnc.add(cSpindle);
cnc.position.set(8, -1.5, -5); mainScene.add(cnc);

let targetCameraPos = new THREE.Vector3(0, 5, 12);
let targetControlsCenter = new THREE.Vector3(0, 0, -5);
mainCamera.position.copy(targetCameraPos);

function resetMainView() {
    targetCameraPos.set(0, 5, 12); targetControlsCenter.set(0, 0, -5);
    galleryView.classList.add('hidden'); mainMenu.classList.remove('hidden');
    cleanupMiniScenes();
}

const mainBtnLogo = document.getElementById('btn-logo');
if (mainBtnLogo) mainBtnLogo.addEventListener('click', resetMainView);

document.getElementById('btn-back').addEventListener('click', resetMainView);

// GESTIONE BOTTONI
document.getElementById('btn-vari').addEventListener('click', () => {
    targetCameraPos.set(0, 4, 6);
    targetControlsCenter.set(0, 0, -5);
    openGallery('vari', 'Vari', '', '#ffffff');
});

document.getElementById('btn-3d').addEventListener('click', () => {
    targetCameraPos.set(-8, 2, 2); targetControlsCenter.set(-8, 0, -5);
    openGallery('3d', 'Stampa 3D', 'text-red', '#f44336');
});
document.getElementById('btn-laser').addEventListener('click', () => {
    targetCameraPos.set(0, 3, -1); targetControlsCenter.set(0, -1, -8);
    openGallery('laser', 'Laser', 'text-green', '#20be0c');
});
document.getElementById('btn-cnc').addEventListener('click', () => {
    targetCameraPos.set(8, 3, 2); targetControlsCenter.set(8, 0, -5);
    openGallery('cnc', 'CNC', 'text-blue', '#4da6ff');
});

window.addEventListener('resize', () => {
    mainCamera.aspect = window.innerWidth / window.innerHeight; mainCamera.updateProjectionMatrix();
    mainRenderer.setSize(window.innerWidth, window.innerHeight);
});

// --- COPIA EMAIL ---
const emailBtns = document.querySelectorAll('.email-btn');

emailBtns.forEach(btn => {
    btn.addEventListener('click', () => {
        const email = btn.getAttribute('data-email');
        const tooltip = btn.querySelector('.tooltip');

        navigator.clipboard.writeText(email).then(() => {
            tooltip.textContent = 'Copiato!';
            btn.classList.add('copied');

            setTimeout(() => {
                btn.classList.remove('copied');
                setTimeout(() => {
                    tooltip.textContent = 'Copia';
                }, 300);
            }, 2000);
        }).catch(err => {
            console.error('Errore nella copia: ', err);
            tooltip.textContent = 'Errore!';
        });
    });
});

const clock = new THREE.Clock();
function animate() {
    requestAnimationFrame(animate);
    const t = clock.getElapsedTime();
    pExtruder.position.x = Math.sin(t * 2) * 0.8;
    lHead.position.set(Math.cos(t) * 1.5, 0.5, Math.sin(t * 1.5));
    cSpindle.position.x = Math.sin(t * 1.2) * 1.2; cSpindle.rotation.y = t * 10;
    mainCamera.position.lerp(targetCameraPos, 0.05);
    mainControls.target.lerp(targetControlsCenter, 0.05);
    mainControls.update(); mainRenderer.render(mainScene, mainCamera);
}
animate();